import { FunctionComponent, useState } from 'react';
import { Typography, Table, TableRow, TableCell } from '../../tailwindcomponents';
import EditColumn from '../Security/EditColumn';
import { Request, CapabilityTools } from '../../types/capabilityList';

interface ToolsTableProps {
    request: Request,
    setRequest: Function,
    viewMode: boolean,
}

const ToolsTable: FunctionComponent<ToolsTableProps> = ({ request, setRequest, viewMode }) => {
    const [toolsEditIndex, setToolsEditIndex] = useState<number>(-1);

    const generateToolsTableBody = (row: CapabilityTools, index: number) => {
        const onDeletedTool = () => {
            const updatedList = request?.capability_tools.filter((_, i) => i !== (index - 1));
            setRequest((prevState: Request) => ({
                ...prevState,
                capability_tools: updatedList,
            }));
            setToolsEditIndex(-1);
        }
        return (
            <TableRow >
                <TableCell>{row.tool_name}</TableCell>
                <TableCell>{row.part_number}</TableCell>
                {!viewMode ? <EditColumn
                    abort={false}
                    index={index}
                    saveChanges={() => { setToolsEditIndex(-1) }}
                    deleteRow={() => onDeletedTool()}
                    editRow={toolsEditIndex}
                    setEditRow={(editRow: number) => { setToolsEditIndex(index) }}
                /> : <TableCell></TableCell>}
            </TableRow>
        )
    }
    return (
        <>
            <div className="flex flex-wrap justify-center mt-4">
                <Typography color='primary' variant='h2' text={"Tools"} align='center' />
            </div>
            <div className="flex flex-wrap justify-center items-center">
                <div className="w-4/5">
                    <Table
                        headers={["tool name", "part number", ""]}
                        rows={request.capability_tools}
                        generateBody={(row: any, index: number) => generateToolsTableBody(row, index)}
                        pagination={false}
                        skipIndexCol={true}
                    />
                </div>
            </div>
        </>
    )
}

export default ToolsTable;